// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__35CaS","label":"Labeled_label__7rXO5","divider":"Labeled_divider__2V7B4"};